import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const TopThreeFisherman = ({ open, onClose, selectedLeaderboard }) => {
  const [fishermen, setFishermen] = useState([]);

  useEffect(() => {
    if (open && selectedLeaderboard) {
      processFishermen();
    }
  }, [open, selectedLeaderboard]);

  const processFishermen = () => {
    if (selectedLeaderboard && Array.isArray(selectedLeaderboard.results)) {
      const formattedResults = selectedLeaderboard.results.map((result, index) => ({
        id: index + 1,
        fisherman: result.fisherman || 'N/A',
        total_weight: result.total_weight || 0,
      }));
      console.log("Formatted fishermen data:", formattedResults);
      setFishermen(formattedResults);
    } else {
      setFishermen([]);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{selectedLeaderboard?.name} - Fishermen Rankings</DialogTitle>
      <DialogContent>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Rank</TableCell>
                <TableCell>Fisherman</TableCell>
                <TableCell>Total Weight (lbs)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fishermen.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{row.fisherman}</TableCell>
                  <TableCell>{row.total_weight.toFixed(2)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default TopThreeFisherman;